import { Alert, AlertTitle, Button, Typography } from "@mui/material";
import type { DataImportInfo } from "../../../api/types/dataImportTypes";
import type { ResourceChangeProgressNotification } from "../../../api/types/resourceChangesTypes";

interface Props {
  dataImport: DataImportInfo;
  progress?: ResourceChangeProgressNotification;
  onRefresh: () => void;
}

const formatProgress = ({ statusText, processedCount, percent }: ResourceChangeProgressNotification) =>
  `${statusText}: ${processedCount.toLocaleString()} records processed${typeof percent === "number" ? ` (${percent}%)` : ""}`;

const getTitle = ({ validationResult, rollbackResult }: DataImportInfo) => {
  if (rollbackResult?.isCompleted === false) {
    return "Rollback in progress";
  }

  return validationResult?.isFinished === false ? "Validation in progress" : "Import in progress";
};

const RunningOperationAlert = ({ dataImport, progress, onRefresh }: Props) => {
  return (
    <Alert severity="info" sx={{ position: "relative" }}>
      <AlertTitle>{getTitle(dataImport)}</AlertTitle>
      <Button
        variant="text"
        color="inherit"
        sx={{ position: "absolute", right: 12, top: 12, py: 0 }}
        onClick={onRefresh}
      >
        Refresh
      </Button>
      <Typography>Depending on the size, it can take a few minutes.</Typography>
      {progress && <Typography sx={{ mt: 1 }}>{formatProgress(progress)}</Typography>}
    </Alert>
  );
};

export default RunningOperationAlert;
